import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../../../../../console/src/plugins/i18n'

const base = 'google_provisioning'

// Regular authenticated route
AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})

// Public route for master authorization (accessed from slave domains)
// Protected by token in URL query parameter
AdminRouter.addRoute({
  name: `${base}.public`,
  path: `/${base}/public`,
  component: () => import('./Index.vue'),
  meta: {
    auth: false,
  },
})

// AdminSidebar.pushItem({
//   id: `${base}`,
//   order: 200,
//   header: $vm => $vm.$t(`general.menu_settings`),
//   text($vm) {
//     return $vm.$t(`${base}.title`)
//   },
//   route: {
//     name: `${base}`,
//   },
//   icon: 'icon-google',
//   permission($vm) {
//     return $vm.$allows('administer')
//   },
// })

messageGroups.push(base)

